import { Tag } from "features/shared/types/tag";
import { AppThunk } from "services/redux/rootReducer";
import addOneLog from "features/panelManagement/logging/actions/set.addOneLog";
import batchOperations from "services/firebase/batchOperations";

const addManyTags =
    (tags: Array<Tag>): AppThunk<Promise<void>> =>
    async (dispatch) => {
        await batchOperations(async (batch, db, batchedTags) => {
            await Promise.all(
                batchedTags.map(async (tag) => {
                    const idRef = db.collection("tags").doc(tag.key);
                    const exists = (await idRef.get()).exists;
                    if (!exists) {
                        batch.set(idRef, tag);
                        return;
                    }
                    const duplicateKey = tag.key + "(copy)";
                    const duplicateTag: Tag = {
                        ...tag,
                        key: duplicateKey,
                    };
                    const duplicateRef = db
                        .collection("tags")
                        .doc(duplicateKey);
                    batch.set(duplicateRef, duplicateTag);
                    return;
                })
            );
        }, tags);

        dispatch(
            addOneLog({
                eventInfo: {
                    description: `Added multiple tags(s) with keys(s) ${tags
                        .map((tag) => tag.key)
                        .join(", ")}`,
                },
            })
        );

        return;
    };

export default addManyTags;
